var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"outer"},_vm._l((_vm.convoyWagonsByExecutionVoyage),function(tripWagon){return _c('v-sheet',{key:tripWagon.id},[_c('TripWagonExecutionViewPanel',{attrs:{"tripWagon":tripWagon,"convoyWagon":tripWagon.convoyWagon}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }